import VideoThumbnailField from '../../components/VideoThumbnailField';
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert,
  Autocomplete,
  Box,
} from '@mui/material';

export default function EditAiStoryDialog({
  open,
  thumbnail,
  setThumbnail,
  thumbnailBusy,
  setThumbnailBusy,
  onClose,
  editItem,
  editTitle,
  setEditTitle,
  editContext,
  setEditContext,
  editChannel,
  setEditChannel,
  editVoiceConfig,
  setEditVoiceConfig,
  editChannels,
  editChannelsLoading,
  voiceConfigsForEdit,
  voiceConfigsLoading,
  editError,
  setEditError,
  handleSaveEdit,
  savingEdit,
  onOpenAddChannel,
}) {
  return (
    <Dialog open={open} onClose={savingEdit || thumbnailBusy ? undefined : onClose} maxWidth='sm' fullWidth>
      <DialogTitle>Edit AI story</DialogTitle>
      <DialogContent>
        {editError && (
          <Alert severity='error' sx={{ mb: 2 }} onClose={() => setEditError(null)}>
            {editError}
          </Alert>
        )}
        {editItem && (
          <>
            <TextField
              margin='dense'
              fullWidth
              label='Video title'
              value={editTitle}
              onChange={(e) => {
                setEditTitle(e.target.value);
                setEditError(null);
              }}
              sx={{ mb: 2 }}
            />
            {open && (
              <VideoThumbnailField
                key={editItem?.id}
                videoId={editItem?.id}
                kind='ai-stories'
                title={editTitle}
                value={thumbnail}
                onChange={setThumbnail}
                disabled={savingEdit || thumbnailBusy}
                onBusyChange={setThumbnailBusy}
              />
            )}
            <TextField
              fullWidth
              multiline
              minRows={3}
              label='Context (optional)'
              value={editContext}
              onChange={(e) => setEditContext(e.target.value)}
              sx={{ mb: 2 }}
            />
            <Autocomplete
              options={editChannels}
              getOptionLabel={(o) =>
                o ? `${o.name} (profile ${o.profileNumber ?? '—'})` : ''
              }
              value={editChannel}
              onChange={(_, v) => setEditChannel(v)}
              loading={editChannelsLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Channel (optional)'
                  margin='dense'
                  placeholder='For render filenames & voice defaults'
                />
              )}
              sx={{ mb: 2 }}
            />
            <Box sx={{ mb: 2 }}>
              <Button size='small' onClick={onOpenAddChannel}>
                Add new channel
              </Button>
            </Box>
            <Autocomplete
              options={voiceConfigsForEdit}
              getOptionLabel={(o) => (o ? o.name || o.voice_id || o.id : '')}
              value={editVoiceConfig}
              onChange={(_, v) => setEditVoiceConfig(v)}
              loading={voiceConfigsLoading}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label='Voice over config (optional)'
                  margin='dense'
                  placeholder='Auto TTS after script completes'
                  helperText='Leave empty to use the channel’s default voice.'
                />
              )}
            />
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={savingEdit || thumbnailBusy}>
          Cancel
        </Button>
        <Button variant='contained' onClick={handleSaveEdit} disabled={savingEdit || thumbnailBusy}>
          {savingEdit ? 'Saving...' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
